import { call, takeLatest, put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';

import {
  TAction,
  TCurrentTransaction,
  TTransactionsResponse
} from 'shared/types';
import TransactionsService from 'shared/services/TransactionsService';
import BillingsService from 'shared/services/BillingsService';

import {
  getTransactionsData,
  getCurrentTransaction as getOneTransaction,
  setTransactionsData,
  setCurrentTransaction,
  getTransactionsFail
} from './transactions.redux';
import { IPaymentIntent } from 'shared/interfaces/payment-intent.interface';
import { IPaymentMethod } from 'shared/interfaces/payment-method.interface';

function* getTransactions() {
  try {
    const result: AxiosResponse<TTransactionsResponse> = yield call(
      TransactionsService.getAllTransactions
    );

    yield put(setTransactionsData(result));
  } catch (error) {
    console.log('error', error);
    yield put(getTransactionsFail());
  }
}

function* getCurrentTransaction({ payload }: TAction<TCurrentTransaction>) {
  try {
    const result: IPaymentIntent = yield call(
      TransactionsService.getOneTransaction,
      payload
    );

    let paymentMethod: IPaymentMethod | null = null;
    if (result.paymentMethod) {
      paymentMethod = yield call(BillingsService.getPaymentMethodData, {
        id: result.paymentMethod,
        patient: result.order.patient.id
      });
    }

    yield put(
      setCurrentTransaction({
        currentTransaction: result,
        paymentMethod: paymentMethod
      })
    );
  } catch (error) {
    console.log('error', error);
    yield put(getTransactionsFail());
  }
}

function* Transactions() {
  yield takeLatest(getTransactionsData.type, getTransactions);
  yield takeLatest(getOneTransaction.type, getCurrentTransaction);
}

export default Transactions;
